/** Ícone de coroa dentária — usado em "Prótese"/"Pedir Prótese" no lugar do Crown (lucide-react),
 *  que representava coroa de realeza, não coroa dentária. Mesmo contrato de ícone do lucide
 *  (`className`, `currentColor`) pra funcionar como drop-in em qualquer lugar que espera
 *  `React.ComponentType<{ className?: string }>`. Fonte: public/coroa-dentaria-icon.svg. */
export function CoroaDentariaIcon({ className }: { className?: string }) {
  return (
    <svg
      width="256"
      height="256"
      viewBox="9 27 230 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M42 107.262C38 94.2623 38 80.2623 42 67.2623C47 51.2623 59 41.2623 75 39.2623C91 37.2623 102 47.2623 115 50.2623C128 52.2623 140 42.2623 155 40.2623C172 37.2623 188 44.2623 198 57.2623C208 70.2623 210 87.2623 205 104.262C203 113.262 196 118.262 186 118.262H61C52 118.262 45 115.262 42 107.262Z"
        stroke="currentColor"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M115 50.9889C125.92 54.9445 135.66 58.9737 147.617 60.5464"
        stroke="currentColor"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M72 159L78 142.923C79 139.538 82 137 87 137H159C164 137 167 139.538 168 142.923L174 159H72Z"
        stroke="currentColor"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60 159H186C193 159 197 166 193 173C186 185 185 201 182 216C179 232 170 244 159 246C148 247 141 239 141 228V211C141 198 134 190 123 190C112 190 105 198 105 211V228C105 239 98 247 87 246C76 244 67 232 64 216C61 201 60 185 53 173C49 166 53 159 60 159Z"
        stroke="currentColor"
        strokeWidth="15"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
